export * from '@primeuix/themes/lara/timeline';
export { default } from '@primeuix/themes/lara/timeline';
